import {Box, Paper, Typography} from "@mui/material";
import {useNavigate, useParams} from "react-router-dom";

const Block = ({programId, block, index}) => {
    const navigate = useNavigate();
    const params = useParams();
    // Check if all weeks are finished
    const allWeeksFinished = block.weeks?.every(week => week.finished) ?? false;
    // Check if no weeks have started
    const noWeeksStarted = block.weeks?.every(week => !week.finished) ?? true;

    // Determine status
    const getStatus = () => {
        if (allWeeksFinished) {
            return {text: "✓ הושלם", bgColor: "#009689", textColor: "#FFFFFF"};
        } else if (noWeeksStarted) {
            return {text: "לא התחיל", bgColor: "#F3F4F6", textColor: "#4A5565"};
        } else {
            return {text: "✓ הושלם", bgColor: "#009689", textColor: "#FFFFFF"};
        }
    };

    const status = getStatus();

    return (
        <Paper
            sx={{
                backgroundColor: allWeeksFinished ? "rgba(240, 253, 250, 0.3)" : "#FFFFFF",
                border: allWeeksFinished ? "1px solid #96F7E4" : "1px solid #E5E7EB",
                borderRadius: "10px",
                direction: "rtl",
                overflow: "hidden",
                padding: "17px"
            }}
            elevation={0}
        >
            {/* Header Row */}
            <Box sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px"
            }}>
                {/* Status Badge */}
                <Box sx={{
                    backgroundColor: status.bgColor,
                    color: status.textColor,
                    padding: "3px 9px",
                    borderRadius: "8px",
                    fontSize: "12px",
                    fontWeight: 500,
                    lineHeight: "16px",
                    height: "22px",
                    display: "flex",
                    alignItems: "center"
                }}>
                    {status.text}
                </Box>

                {/* Block Title and Weeks Count */}
                <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
                    <Typography sx={{
                        fontSize: "14px",
                        color: "#6A7282",
                        fontWeight: 400,
                        lineHeight: "20px"
                    }}>
                        {block.weeks?.length ?? 0} שבועות
                    </Typography>
                    <Typography sx={{
                        fontWeight: 400,
                        fontSize: "16px",
                        color: "#0A0A0A",
                        lineHeight: "24px"
                    }}>
                        בלוק {index}
                    </Typography>
                </Box>
            </Box>

            {/* Week Chips Row */}
            <Box sx={{
                display: "flex",
                flexDirection: "row-reverse",
                gap: "4px",
                flexWrap: "wrap"
            }}>
                {block.weeks?.sort((a, b) => a.index - b.index).map((week, weekIndex) => (
                    <Box
                        key={weekIndex}
                        onClick={() => navigate(`/app/clients/${params.userId}/${programId}/week/${block.index}/${weekIndex}`)}
                        sx={{
                            backgroundColor: week.finished ? "#00BBA7" : "#E5E7EB",
                            height: "32px",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flex: "1 1 auto",
                            minWidth: "0",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            "&:hover": {
                                transform: "translateY(-2px)",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                backgroundColor: week.finished ? "#009A8C" : "#D1D5DB"
                            }
                        }}
                    >
                        <Typography sx={{
                            fontSize: "12px",
                            fontWeight: 400,
                            lineHeight: "16px",
                            color: week.finished ? "#FFFFFF" : "#4A5565"
                        }}>
                            {weekIndex + 1}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Paper>
    );
};

export default Block;